import PropTypes from 'prop-types';
import { withConfig } from 'hoc/config.hoc';
import { get } from 'helpers/objectHelpers';
import { paths } from './config.paths';

const TextFromConfig = props => {
  const { config, defaultText, path } = props;

  if (config === null) {
    return defaultText;
  } else {
    if (!Array.isArray(path)) {
      return defaultText;
    }

    const text = get(config, path, defaultText);

    if (typeof text === 'string') {
      return text;
    } else {
      return defaultText;
    }
  }
};

TextFromConfig.propTypes = {
  defaultText: PropTypes.string,
  path: PropTypes.arrayOf(PropTypes.string).isRequired,
};

TextFromConfig.defaultProps = {
  defaultText: '',
};

const connectedTextFromConfig = withConfig(TextFromConfig);

connectedTextFromConfig.paths = paths;
export default connectedTextFromConfig;
